import { styled } from '@mui/material/styles';

export const StyledFilter = styled('div')`
  padding: 24px 24px 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;

  .filter-container {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .metrics-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  @media only screen and (max-width: 900px) {
    .last-updated {
      margin: 8px 0;
    }
  }
  @media only screen and (max-width: 1280px) {
    flex-direction: column;
    align-items: flex-start;
    .filter-container {
      margin-top: 12px;
    }
  }
`;
